import { IKnmAddressType } from 'APIPackage/CatalogsModule/interfaces/IKnmAddressType';

import { IKnmAddressTypeSelectOption } from '../interfaces/IKnmAddressTypeSelectOption';

export const createKnmAddressTypeSelectOption = (knmAddressType: IKnmAddressType): IKnmAddressTypeSelectOption => ({
  ...knmAddressType,
  label: knmAddressType.name,
  value: knmAddressType.code,
});
